import { Component, OnInit, Input, Output, EventEmitter, ViewContainerRef } from '@angular/core';
import { Http, Response } from '@angular/http';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { NEW_SERIES_SA } from '../../models/seriessa';
import { HeaderService } from '../../header.service';
import * as Globals from '../../globals';

declare var $: any;

@Component({
  selector: 'app-subagent',
  templateUrl: './subagent.component.html',
  styleUrls: ['./subagent.component.css']
})
export class SubagentComponent implements OnInit {

  @Input() userProfile: any;
  @Input() cdAucType: any;
  loading: boolean = false;
  @Input() ssId: number;
  @Input() seriesId: number;
  @Input() authMenu: any;
  @Input() parentSsId: number;
  part: any[];
  seriessa: NEW_SERIES_SA;
  @Output() refreshSeries = new EventEmitter;
  @Output() refreshSubAgentList = new EventEmitter;
  constructor(
    private http: Http,
    public toastr: ToastsManager, vRef: ViewContainerRef, private headerService: HeaderService
  ) {
    this.toastr.setRootViewContainerRef(vRef);
  }

  ngOnInit() {
    this.newSeriessa();
    this.getPart();
  }

  newSeriessa() {
    this.seriessa = new NEW_SERIES_SA(null, null, 0, null, null, null, this.userProfile.USER_ID, null, null, null, null);
  }

  getSeriesSa() {
    this.loading = true;
    this.http.get(Globals.serviceUrl + 'ritel/seriessa?Id=' + this.ssId + '&t=' + new Date().getTime(), { headers: this.headerService.getHeader() })
      .subscribe((res: Response) => {
        this.seriessa = res.json();
        this.loading = false;
      }, err => {
        console.log(err);
        this.toastr.error(Globals.errorMessage(err));
        this.loading = false;
      });
  }

  getPart() {
    this.loading = true;
    this.http.get(Globals.serviceUrl + 'ref/parts?inst=1&search=&t=' + new Date().getTime(), { headers: this.headerService.getHeader() })
      .subscribe((res: Response) => {
        this.part = res.json();
        if (this.ssId > 0) {
          this.getSeriesSa();
        }
        this.loading = false;
      }, err => {
        console.log(err);
        this.toastr.error(Globals.errorMessage(err));
        this.loading = false;
      });
  }

  loadParent(val: any) {
    if (this.parentSsId == 0) {
      this.refreshSeries.emit({ ssId: this.seriessa.SS_ID, saCode: this.seriessa.SA_CODE, mode: val });
    } else {
      this.refreshSubAgentList.emit({ ssId: this.seriessa.SS_ID, saCode: this.seriessa.SA_CODE, mode: val });
    }

  }

  saveSeriessa() {
    this.loading = true;
    if (this.parentSsId > 0) {
      this.seriessa.PARENT_ID = this.parentSsId;
    }
    if (this.ssId == 0) {
      this.seriessa.SERIES_ID = this.seriesId;
      this.http.post(Globals.serviceUrl + 'ritel/seriessa', this.seriessa, { headers: this.headerService.getHeader() })
        .subscribe((res: Response) => {
          this.seriessa = res.json();
          this.toastr.success('Data berhasil disimpan');
          this.ssId = this.seriessa.SS_ID;
          this.loadParent(1);
          this.getSeriesSa();
          this.loading = false;
        }, err => {
          console.log(err);
          this.toastr.error(Globals.errorMessage(err));
          this.loading = false;
        });
    } else {
      this.http.put(Globals.serviceUrl + 'ritel/seriessa?id=' + this.seriessa.SS_ID, this.seriessa, { headers: this.headerService.getHeader() })
        .subscribe((res: Response) => {
          this.toastr.success('Data berhasil disimpan');
          this.loadParent(1);
          this.loading = false;
        }, err => {
          console.log(err);
          this.toastr.error(Globals.errorMessage(err));
          this.loading = false;
        });
    }
  }

  deleteSeriessa() {
    this.http.delete(Globals.serviceUrl + 'ritel/seriessa?id=' + this.seriessa.SS_ID, { headers: this.headerService.getHeader() })
      .subscribe((res: Response) => {
        $('#modal').modal('hide');
        this.toastr.success('Data berhasil dihapus');
        this.loadParent(0);
      }, err => {
        console.log(err);
        this.toastr.error(Globals.errorMessage(err));
        this.loading = false;
      });
  }

}



// WEBPACK FOOTER //
// C:/Users/oggy.yuristantyo/source/Workspaces/UI_SBN_Ritel_Web/src/app/auction/subagent/subagent.component.ts